import icons from "../../../icons/timeline/nftInstance";
import TimelineItemIcon from "../../../timeline/itemIcon";

export default function NftInstanceTimelineItemIcon({ name }) {
  return <TimelineItemIcon icons={icons} name={name} />;
}
